__turbopack_context__.v({
  "contentWrapper": "page-module-scss-module__WATCXW__contentWrapper",
  "mainContainer": "page-module-scss-module__WATCXW__mainContainer",
});
